import { Inject, Injectable, DOCUMENT } from "@angular/core";

import { Store } from '@ngxs/store';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatActions from "@medsurf/flat-actions";
import * as FlatStates from "@medsurf/flat-states";


@Injectable({
	providedIn: 'root'
})
export class ThemeControlFacade {
	constructor(private store: Store,
	            @Inject(DOCUMENT) private document: Document) {
	}
	
	toggleTheme() {
		// Change Theme
		switch (this.store.selectSnapshot(FlatStates.SlideAuthorState.theme$)) {
			case FlatModels.SlideAuthorModels.MedsurfTheme.enum.light:
				this.store.dispatch(new FlatActions.SlideAuthorActions.SetTheme(FlatModels.SlideAuthorModels.MedsurfTheme.enum.dark));
				break;
			default:
				this.store.dispatch(new FlatActions.SlideAuthorActions.SetTheme(FlatModels.SlideAuthorModels.MedsurfTheme.enum.light));
				break;
		}
		
		// Apply Theme
		this.applyTheme();
	}
	
	applyTheme() {
		const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
		themeLink.href = FlatModels.SlideAuthorModels.MedsurfThemeStyleFile[this.store.selectSnapshot(FlatStates.SlideAuthorState.theme$)] as string;
	}
}